import { type DetailedPaymentPrefUnionObjectType } from "../../common/types";

/**
 * For check payment prefs, if using the same account mailing address, we cannot reveal the info since
 * we must query that info from the backend. Product is ok with not having that functionality for check
 * same account mailing address payment prefs for now.
 * @param paymentPref Payment pref to determine whether it can be revealed or not.
 * @returns
 */
export const isRevealablePaymentPref = (paymentPref: DetailedPaymentPrefUnionObjectType) => {
  if (paymentPref.__typename === "CheckPaymentPrefObjectType") {
    return !paymentPref.useAccountMailingAddress;
  }
  return true;
};
